// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const extractionInFileIdsMax = 10;

export const extractionInHintOneMax = 500;

export const ExtractionIn = zod.object({
  "file_ids": zod.array(zod.uuid()).min(1).max(extractionInFileIdsMax),
  "hint": zod.union([zod.string().max(extractionInHintOneMax),zod.null()]).optional(),
  "kind": zod.enum(['platform', 'accelerator', 'framework', 'offer'])
});

export type ExtractionIn = zod.input<typeof ExtractionIn>;
export type ExtractionInOutput = zod.output<typeof ExtractionIn>;
